import { render, staticRenderFns } from "./shareImg.vue?vue&type=template&id=6cf434d4&scoped=true"
import script from "./shareImg.vue?vue&type=script&lang=js"
export * from "./shareImg.vue?vue&type=script&lang=js"
import style0 from "./shareImg.vue?vue&type=style&index=0&id=6cf434d4&prod&scoped=true&lang=css"
import style1 from "./shareImg.vue?vue&type=style&index=1&id=6cf434d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf434d4",
  null
  
)

export default component.exports